import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OfferCard } from '../OfferCard';
import { EcgLine } from '../EcgLine';
import { finalIncludes } from '../../data/content';
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-navy-950 px-5 py-16 text-white md:py-24" aria-labelledby="final-title" data-id="element-178" data-mp="3msqqgbhvk4nu">
      <EcgLine animated beats={8} className="absolute left-0 top-8 h-14 w-full opacity-25" data-id="element-179" data-mp="3rr0kujvrz18e" />
      <div className="relative mx-auto max-w-6xl" data-id="element-180" data-mp="3drisjuj9t5ua">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-gold sm:text-sm" data-id="element-181" data-mp="3hufbjmcq33yr">
          Ready to organize your ECG interpretation studies?
        </p>
        <h2 id="final-title" className="mx-auto mt-3 max-w-4xl text-center font-display text-3xl font-black leading-tight sm:text-5xl text-balance" data-id="element-182" data-mp="38tqxwsr8r5me">
          Build a More Structured Approach to ECG Interpretation — One Focused Study Session at a Time
        </h2>

        <div className="mt-12 grid gap-10 lg:grid-cols-2 lg:items-center" data-id="element-183" data-mp="q8dhgzjf70ta">
          <div data-id="element-184" data-mp="q6ittdgrkuli">
            <p className="text-lg leading-relaxed text-white/80" data-id="element-185" data-mp="l9k18zcr0vpf">
              You don’t need another collection of disconnected rhythm charts. You need a clear educational pathway that
              helps you connect cardiac electrical fundamentals, rhythm recognition, waveform analysis, 12-lead ECG
              concepts, and simulated interpretation exercises.
            </p>
            <p className="mt-4 text-lg font-bold" data-id="element-186" data-mp="7bvjw1hw46p4">That’s what the ECG Interpretation Blueprint™ is designed to provide.</p>

            <h3 className="mt-8 font-display text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-187" data-mp="ga7iapp008s4">
              Your complete collection includes
            </h3>
            <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-188" data-mp="bdh3s6sudl8t">
              {finalIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold" data-id="element-189" data-mp="1rrflx8rtlkv8">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-heal" data-id="element-190" data-mp="1msvwgye0pqy4">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-191" data-mp="pby8d6h6i0za" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <OfferCard ctaLabel="Yes! I want the ECG Interpretation Blueprint™" data-id="element-192" data-mp="ydejxhjqc953" />
        </div>
      </div>
    </section>;
}